module.exports = __webpack_public_path__ + "assets/menu-parent-portal-bg.162f3234.svg";